import axios from "axios";
import { BaseUrlApi } from "../utilities/BaseUrl";

export const ApiService = axios.create({
    baseURL:BaseUrlApi,
    headers:{
        'Accept': 'application/json',
        // 'Content-Type': 'application/json',
    }
})